import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { sendResetRequest } from '../services/PasswordResetService';
import { FormFeedback } from './FormFeedback';

function ForgotPasswordForm({ typeCallback }) {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  async function recoverPassword(e) {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    const result = await sendResetRequest(username);
    setLoading(false);

    if (result === 'time') {
      setErrorMessage('Please wait at least 5 minutes between reset requests.');
    } else {
      setSuccessMessage('Check your email for a reset link.');
    }
  }

  return (
    <Form className="lf-form" onSubmit={recoverPassword} noValidate>
      <p className="lf-subtext">
        Enter your username and we'll send a reset link to your registered email address.
      </p>
      <Form.Control
        className="lf-input"
        type="text"
        placeholder="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        autoComplete="username"
        disabled={loading}
      />
      <FormFeedback type="loading" message={loading ? 'Sending\u2026' : null} />
      <FormFeedback type="error" message={errorMessage} />
      <FormFeedback type="success" message={successMessage} />
      <Button
        className="btn-register"
        type="submit"
        disabled={loading || !username}
      >
        {loading ? 'Sending\u2026' : 'Send Reset Link'}
      </Button>
      {typeCallback && (
        <button
          type="button"
          className="lf-back-link"
          onClick={() => typeCallback('login')}
        >
          ← Back to Login
        </button>
      )}
    </Form>
  );
}

export { ForgotPasswordForm };
